//Allow users to manage their profiles, including setting
//nutritional goals and preferences
// src/components/UserProfile.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UserProfile = () => {
  const [user, setUser] = useState({});

  useEffect(() => {
    const fetchUser = async () => {
      const response = await axios.get('/api/users/me');
      setUser(response.data);
    };
    fetchUser();
  }, []);

  return (
    <div>
      <h2>{user.name}'s Profile</h2>
      <p>Email: {user.email}</p>
      <p>Goal: {user.goal}</p>
    </div>
  );
};

export default UserProfile;
